import { GameDayModel } from '../../models/gameday-model';

export function orderIsLowPriorityType(order: GameDayModel.Order): boolean {
  return order.retailType === GameDayModel.RetailType.lowPriority;
}

export function orderIsRetailType(order: GameDayModel.Order): boolean {
  return (
    order.retailType === GameDayModel.RetailType.full ||
    order.retailType === GameDayModel.RetailType.lowPriority
  );
}
